import PropTypes from "prop-types";
import { PASSWORD_RULES } from "./adminConstants";
import {
    labelStyle,
    modalBackdropStyle,
    modalCloseButtonStyle,
    modalDangerButtonStyle,
    modalHeaderStyle,
    modalSecondaryButtonStyle,
    modalStyle,
} from "./styles/adminDashboardStyles";
import ModalBackdrop from "../../components/ModalBackdrop";

export function PasswordConditions({ password }) {
    if (password.length === 0) return null;
    return (
        <div style={{ marginTop: "6px", display: "flex", flexDirection: "column", gap: "3px" }}>
            {PASSWORD_RULES.map(rule => {
                const ok = rule.test(password);
                return (
                    <span key={rule.label} style={{ fontSize: "11px", color: ok ? "#15803d" : "#dc2626", display: "flex", alignItems: "center", gap: "4px" }}>
                        <span>{ok ? "✓" : "✗"}</span>
                        {rule.label}
                    </span>
                );
            })}
        </div>
    );
}

PasswordConditions.propTypes = { password: PropTypes.string.isRequired };

export function FieldLabel({ children, required, htmlFor, style }) {
    return (
        <label htmlFor={htmlFor} style={{ ...labelStyle, ...style }}>
            {children}
            {required && <span style={{ color: "#ef4444", marginLeft: "2px" }}>*</span>}
        </label>
    );
}
FieldLabel.propTypes = {
    children: PropTypes.node.isRequired,
    required: PropTypes.bool,
    htmlFor: PropTypes.string,
    style: PropTypes.object,
};

export function ConfirmDeleteModal({ title, children, confirmLabel = "Supprimer définitivement", deleting, onCancel, onConfirm }) {
    return (
        <div style={modalBackdropStyle}>
            <ModalBackdrop onClose={() => !deleting && onCancel()} />
            <div
                role="dialog"
                aria-modal="true"
                aria-label={title}
                style={{ ...modalStyle, position: "relative", zIndex: 1 }}
            >
                <div style={modalHeaderStyle}>
                    <h2 style={{ margin: 0, fontSize: "18px" }}>{title}</h2>
                    <button type="button" onClick={onCancel} disabled={deleting} aria-label="Fermer" style={modalCloseButtonStyle}>×</button>
                </div>
                <div style={{ display: "grid", gap: "18px" }}>
                    <p style={{ margin: 0, color: "#374151", lineHeight: 1.6 }}>
                        {children}
                    </p>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <button
                            type="button"
                            onClick={onCancel}
                            disabled={deleting}
                            style={modalSecondaryButtonStyle}
                        >
                            Annuler
                        </button>
                        <button
                            type="button"
                            onClick={onConfirm}
                            disabled={deleting}
                            style={modalDangerButtonStyle}
                        >
                            {deleting ? "Suppression…" : confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

ConfirmDeleteModal.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    confirmLabel: PropTypes.string,
    deleting: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
